import * as React from "react";
import { FilterOption } from "../types";

export const useFilterLogic = (
  _filterOptions: FilterOption[],
  onFilterChange?: (filters: string[]) => void
) => {
  const [selectedFilters, setSelectedFilters] = React.useState<string[]>([]);

  // Notify parent of filter changes
  React.useEffect(() => {
    if (onFilterChange) onFilterChange(selectedFilters);
  }, [selectedFilters, onFilterChange]);
  const [showLeftArrow, setShowLeftArrow] = React.useState(false);
  const [showRightArrow, setShowRightArrow] = React.useState(false);
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const checkScroll = () => {
      if (scrollContainerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } =
          scrollContainerRef.current;
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
      }
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  const handleScroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const toggleFilter = (filterId: string) => {
    setSelectedFilters((prev) =>
      prev.includes(filterId)
        ? prev.filter((id) => id !== filterId)
        : [...prev, filterId],
    );
  };

  const clearAllFilters = () => {
    setSelectedFilters([]);
  };

  return {
    selectedFilters,
    showLeftArrow,
    showRightArrow,
    scrollContainerRef,
    handleScroll,
    toggleFilter,
    clearAllFilters,
  };
};
